import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';

interface TournamentMatchesLinkProps {
  tournamentId: string | number;
}

/**
 * Compact "All matches ›" link to a tournament's match list, sized for a
 * section header's right slot. Used on a tournament match page opened from
 * outside the tournament (the standalone match page), where back returns
 * there instead.
 */
export const TournamentMatchesLink: React.FC<TournamentMatchesLinkProps> = ({ tournamentId }) => {
  const { t } = useTranslation('tournament');

  return (
    <Link
      to={`/tournaments/${tournamentId}`}
      className={styles.link}
      data-testid="tournament-matches-link"
    >
      {t('allTournamentMatches')}
      <i className="icon-chevron-right" aria-hidden="true" />
    </Link>
  );
};

export default TournamentMatchesLink;
